import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import {
  Box,
  Typography,
  CircularProgress,
  Grid,
  Card,
  IconButton,
  Button,
  Modal,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
  Alert,
  Snackbar,
  Pagination,
} from "@mui/material";
import axios from "axios";
import { motion } from "framer-motion";

import { WorkOutline, LocationOn, Search } from "@mui/icons-material";
import { Link, useNavigate } from "react-router-dom";
import ShareIcon from "@mui/icons-material/Share";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import SchoolIcon from "@mui/icons-material/School";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { GridView, ViewList } from "@mui/icons-material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  applyJob,
  FilterOtherJobs,
  getApplicantHistory,
  getAppliedJobs,
  getOpenJobs,
  getSingleJobDesc,
  getSingleOpenJob,
  saveParticularJob,
} from "../../../../Redux/Reducers/JobReducer";
import SearchIcon from "@mui/icons-material/Search";
import { ShareProfile } from "../ProfileConnectionComponents";
import { useQuantityContext } from "../../../QuantityContext";
import "../../../../Assets/css/Jobs/OtherJobs.css";
import FilterComponent from "./FilterComponent";
import CandidatePagination from "./CandidatePagination";
import { getVideoResumeReducer } from "../../../../Redux/Reducers/ProfileReducer";
import AllCardsSkeleton from "../../../LoadingSkeleton/AllCardsSkeleton";
import JobsCardsSkeleton from "../../../LoadingSkeleton/JobsCardsSkeleton";
import { Helmet } from 'react-helmet';


const OtherJobs = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [jobs, setJobs] = useState([]); // Stores all job data
  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state
  // const [viewMode, setViewMode] = useState("grid"); // Grid/List view mode
  const [logourl, setLogourl] = useState({}); // Map of job IDs to logos
  const objectId = localStorage.getItem("objectId"); // User-specific token
  // const [filteredJobs, setFilteredJobs] = useState([]); // Jobs after filtering
  const [searchKeyword, setSearchKeyword] = useState(""); // Search keyword
  const [showSearchBar, setShowSearchBar] = useState(false); // Toggle search bar
  const [showFilterDropdown, setShowFilterDropdown] = useState(false); // Toggle filter dropdown
  const [isVisible, setIsVisible] = useState(false); // For animation visibility
  const { filteredOthersJobs, viewMode } = useSelector(
    (state) => state.jobs || {}
  );
  // const [page, setPage] = useState(0);
  const { totalPages, currentPage } = useSelector((state) => state?.jobs);
  const otherJobs = useSelector((state) => state?.jobs?.allJobs);
  const openJobs = otherJobs?.open_jobs;
  const pagination = otherJobs?.pagination;
  const selectedCompany =
    useSelector((state) => state?.jobs?.selectedCompany) || {};
  const [showResumeModal, setShowResumeModal] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  // const hasResume = Array.isArray(Resumedata) &&
  //   Resumedata.some((item) =>
  //     item?.document_url &&
  //     item.document_url.trim() !== "" &&
  //     item.document_url !== "null" &&
  //     item.document_url !== "undefined"
  //   );
  const Resumedata =useSelector((state) => state?.ProfileArray?.ResumeData?.data) || [];

    const hasResume = Resumedata?.some((item) => item?.document_url);

    const rawVideoUrlArray = useSelector(
      (state) => state?.ProfileArray?.videoResume
    )
  
   const videoUrlArray = Array.isArray(rawVideoUrlArray) ? rawVideoUrlArray : [];
  const hasVideoResume = videoUrlArray?.some((item) => item?.document_url);

  const [appliedFilters, setAppliedFilters] = useState([]);
  const [appliedSearch, setAppliedSearch] = useState("");
  // console.log("videoUrlArray", videoUrlArray)
  const sortJobsByDate = (jobs) => {
    return [...jobs].sort((a, b) => {
      return new Date(b.date_posted) - new Date(a.date_posted);
    });
  };

  // dispatch(getAllJobs(page))
  // console.log("otherJobsNNNN", otherJobs);

  const jobsToDisplay =
    (filteredOthersJobs?.length > 0 ? filteredOthersJobs : "") || [];
  // console.log("showFilterDropdown", showFilterDropdown)
  // const [showSnackbar, setShowSnackbar] = useState(false);
  const { openSnackbar } = useQuantityContext();

  // filteredOthersJobs
  // console.log("otherJobs", otherJobs)
  // console.log("filteredOthersJobs", filteredOthersJobs)
  // const loading = useSelector((state) => state.jobs.isLoading);
  // const { postedJobs, loading, viewMode } = useSelector(state => state.jobs);
  // console.log("otherJobs", otherJobs)
  const popupRef = useRef(null); // For handling outside click
  const [filters, setFilters] = useState({
    searchKeyword: "",
    dept_type: "",
    experience: "",
    edu_level: "",
    role: "",
    location: "",
    mode: "",
  });

  const params = useMemo(
    () => ({
      ...(appliedFilters.company_name && {
        company: appliedFilters.company_name,
      }),
      ...(appliedFilters.dept_type && { department: appliedFilters.dept_type }),
      ...(appliedFilters.role && { role: appliedFilters.role }),
      ...(appliedFilters.location && { location: appliedFilters.location }),
      ...(appliedFilters.skills && { skills: appliedFilters.skills }),
      ...(appliedFilters.mode && { mode: appliedFilters.mode }),
      // Add sort parameters
      ...(appliedFilters.sort_by && { sort_by: appliedFilters.sort_by }),
      ...(appliedFilters.sort_order && {
        sort_order: appliedFilters.sort_order,
      }),
      ...(appliedFilters.only_saved && {
        only_saved: appliedFilters.only_saved,
      }),
      page: pageCount,
      ...(appliedSearch && { search: appliedSearch }),
    }),
    [pageCount, appliedFilters, appliedSearch]
  );


  useEffect(() => {
    const fetchJobs = async () => {
      try {
        setLoading(true); // Start loading
        await dispatch(getOpenJobs(params));
        await dispatch(getApplicantHistory());
        // await dispatch(getVideoResumeReducer());
      } catch (error) {
        console.error("Error fetching jobs:", error);
        setError("Failed to fetch jobs. Please try again later.");
      } finally {
        setLoading(false); // End loading
      }
    };

    fetchJobs();
  }, [params, dispatch]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true); // Trigger animation after a delay
    }, 100); // Adjust delay as needed
    return () => clearTimeout(timer);
  }, []);

  const headers = useMemo(
    () => ({
      "x-api-key": process.env.REACT_APP_API_KEY,
      "Content-Type": "application/json",
      Authorization: `Bearer ${objectId}`,
    }),
    [objectId]
  );

  const handleApplyFilters = (search, filters) => {
    setAppliedFilters(filters);
    setAppliedSearch(search);
    setPageCount(0);
  };

  const handleClearFilters = () => {
    setAppliedFilters({});
    setAppliedSearch("");
    setPageCount(0);
  };

  const handleFilterIconClick = () => {
    // console.log(showFilterDropdown);
    setShowFilterDropdown(!showFilterDropdown);
  };

  // Handle filter changes
  const handleFilterChange = useCallback((key, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [key]: value === prevFilters[key] ? "" : value, // Toggle filter
    }));
  }, []);

  const handleSuccess = (message, severity = "success", autoClose = 6000) => {
    openSnackbar(message, severity, autoClose);
  };

  const handleFailure = (message, severity = "error", autoClose = 6000) => {
    openSnackbar(message, severity, autoClose);
  };

  const [shareProfileConfig, setShareProfileConfig] = useState({
    open: false,
    onClose: undefined,
    qrCodeUrl: "",
    qrCodeLogo: undefined,
    showQr: true,
    isDownload: false,
    profileType: "",
    handleSuccess: handleSuccess,
    handleFailure: handleFailure,
  });

  const updateShareProfileConfig = (newConfig) => {
    setShareProfileConfig((prev) => ({
      ...prev,
      ...newConfig,
    }));
  };

  const handleJobShare = (job) => {
    // setSelectedJob(job);
    updateShareProfileConfig({
      open: true,
      onClose: () =>
        setShareProfileConfig((prev) => ({ ...prev, open: false })),
      qrCodeUrl: `${process.env.REACT_APP_CARD_URL}/job-description/${job.id}`,
      showQr: false,
      profileType: "Job",
      handleSuccess,
      handleFailure,
      shareData: {
        title: job.role ? `${job.role} at ${job.company_name || 'a company'}` : 'Job Opportunity',
        description: [
          job.location && `📍 ${job.location}`,
          job.experience && `💼 ${job.experience}`,
          job.edu_level && `🎓 ${job.edu_level}`
        ].filter(Boolean).join(' | ') || 'Check out this job opportunity',
        image: job.company_logo || 'default_job_image_url',
        url: `${process.env.REACT_APP_CARD_URL}/job-description/${job.id}`,
        company: job.company_name,
        location: job.location
      }
    });
  };

  const parseSkillsArray = (data) => {
    if (!data) return [];

    try {
      // First attempt to parse as JSON
      const parsedData = JSON.parse(data);
      return Array.isArray(parsedData) ? parsedData : [];
    } catch (error) {
      // If JSON parsing fails, check if it's a comma-separated string
      if (typeof data === "string") {
        return data?.split(",").map((skill) => skill.trim());
      }
      // If it's already an array
      if (Array.isArray(data)) {
        return data;
      }
      return [];
    }
  };

  const handleSingleJobClick = (JobId, source = "open-job") => {
    console.log("IAMJob", JobId);
    // dispatch(getSingleJobDesc(JobId));
    navigate(`/job-description/${JobId}`, { state: { source } });
  };

  const handleJobApply = useCallback(
    (jobId) => {
      if (window.confirm("Are you sure you want to apply for this job?")) {
        dispatch(applyJob(jobId))
          .unwrap()
          .then((response) => {
            // alert("You have successfully applied for the job!");
            openSnackbar(
              "You have successfully applied for the job!",
              "success"
            );
            // dispatch(getOpenJobs());
          })
          .catch((error) => {
            // alert(`Failed to apply for the job. ${error.message}`);
            openSnackbar("Failed to apply for the job", "error");
          });
      }
    },
    [dispatch]
  );

  const formatSalary = (salary) => {
    if (!salary) return "Not Specified";

    // Remove all spaces and convert to string
    const cleanSalary = String(salary).replace(/\s/g, "");

    const formatToLakhsAndThousands = (amount) => {
      if (amount >= 100000) {
        const lakhs = (amount / 100000).toFixed(1);
        return `${lakhs}L`;
      } else if (amount >= 1000) {
        const thousands = (amount / 1000).toFixed(1);
        return `${thousands}K`;
      }
      return `${amount.toLocaleString()}`;
    };

    // Handle monthly salary format (e.g. "20,000" or "40,000")
    if (/^₹?\d{1,2},\d{3}$/.test(cleanSalary.replace("₹", ""))) {
      const amount = parseInt(cleanSalary.replace(/[^\d]/g, ""));
      return `${formatToLakhsAndThousands(amount)} per month`;
    }

    // Handle "k" format (e.g. "20k-40K")
    if (/^\d+k-\d+k$/i.test(cleanSalary.toLowerCase())) {
      const [min, max] = cleanSalary.toLowerCase().split("-");
      const minValue = parseInt(min.replace("k", "")) * 1000;
      const maxValue = parseInt(max.replace("k", "")) * 1000;
      return `${formatToLakhsAndThousands(
        minValue
      )} - ${formatToLakhsAndThousands(maxValue)}`;
    }

    // Handle salary with rupee symbol and commas (annual format)
    if (cleanSalary.includes("₹")) {
      const numbers = cleanSalary.match(/[\d,]+/g);
      if (numbers && numbers.length === 2) {
        const min = parseInt(numbers[0].replace(/,/g, ""));
        const max = parseInt(numbers[1].replace(/,/g, ""));
        return `${formatToLakhsAndThousands(min)} - ${formatToLakhsAndThousands(
          max
        )}`;
      }
    }

    // Handle plain number ranges with commas
    if (cleanSalary.includes("-")) {
      const [min, max] = cleanSalary
        .split("-")
        .map((num) => parseInt(num.replace(/[^\d]/g, "")));
      if (!isNaN(min) && !isNaN(max)) {
        // If numbers are in thousands range, assume monthly
        if (min < 100000 && max < 100000) {
          return `${formatToLakhsAndThousands(
            min
          )} - ${formatToLakhsAndThousands(max)}`;
        }
        return `${formatToLakhsAndThousands(min)} - ${formatToLakhsAndThousands(
          max
        )}`;
      }
    }

    // Handle single number
    const singleNumber = parseInt(cleanSalary.replace(/[^\d]/g, ""));
    if (!isNaN(singleNumber)) {
      // If number is in thousands range, assume monthly
      if (singleNumber < 100000) {
        return `${formatToLakhsAndThousands(singleNumber)}`;
      }
      return `${formatToLakhsAndThousands(singleNumber)}`;
    }

    return "Not Specified";
  };

  // Calculate and render posted date
  const calculateDaysAgo = (date) => {
    const postedDate = new Date(date);
    const today = new Date();
    const differenceInTime = today - postedDate; // Difference in milliseconds
    const differenceInDays = Math.floor(
      differenceInTime / (1000 * 60 * 60 * 24)
    ); // Convert to days
    return differenceInDays;
  };

  const renderPostedDate = (date) => {
    const postedDate = new Date(date);
    const now = new Date();
    const diffInMs = now - postedDate;

    const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
    const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
    const diffInMonths = Math.floor(diffInDays / 30);
    const diffInYears = Math.floor(diffInDays / 365);

    if (diffInMinutes < 1) {
      return "just now";
    } else if (diffInMinutes < 60) {
      return `${diffInMinutes}m ${diffInMinutes === 1 ? "" : ""} ago`;
    } else if (diffInHours < 24) {
      return `${diffInHours}h ${diffInHours === 1 ? "" : ""} ago`;
    } else if (diffInDays === 1) {
      return "1d ago";
    } else if (diffInDays < 30) {
      return `${diffInDays}d ago`;
    } else if (diffInMonths < 12) {
      return `${diffInMonths}m ${diffInMonths === 1 ? "" : ""} ago`;
    } else {
      return `${diffInYears}y ${diffInYears === 1 ? "" : ""} ago`;
    }
  };
  const handleJObSearch = (event) => {
    const keyword = event.target.value;
    setSearchKeyword(keyword);

    dispatch(
      FilterOtherJobs({
        ...filters,
        search: keyword,
      })
    );
  };

  const handleJobSave = useCallback(
    (jobId) => {
      dispatch(saveParticularJob(jobId))
        .unwrap()
        .then(() => {
          openSnackbar("Job saved successfully!", "success");
          dispatch(getOpenJobs(params)); // Refresh jobs list to update UI
        })
        .catch((error) => {
          openSnackbar("Failed to save job", "error");
        });
    },
    [dispatch, params]
  );

  const handleAppliedClick = () => {
    navigate("/applicant");
    dispatch(getAppliedJobs());
  };

  // const handleApplyInitiation = (jobId) => {
  //   setSelectedJob(jobId);

  //   if (!hasResume) {
  //     setShowResumeModal(true);
  //   } else if (!hasVideoResume) {
  //     setShowVideoModal(true);
  //   } else {
  //     setShowConfirmationModal(true);
  //   }
  // };

  const handleApplyInitiation = (jobId, e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    console.log("i am from other jobs page", hasVideoResume);
    console.log("hasResume:", hasResume);

    if (!objectId) {
      openSnackbar("Please Login to Apply", "info");
      navigate("/login");
      return;
    }

    setSelectedJob(jobId);

    // Check for resume first
    if (!hasResume) {
      console.log("No resume found, showing resume modal");
      setShowResumeModal(true);
      return; // Important: return here to stop further execution
    }

    // Then check for video resume
    if (!hasVideoResume) {
      console.log("No video resume found, showing video modal");
      setShowVideoModal(true);
      return; // Important: return here to stop further execution
    }

    // Only show confirmation modal if both resume and video resume exist
    console.log("Both resume and video resume exist, showing confirmation modal");
    setShowConfirmationModal(true);
  };


  const handleJobApplyConfirmation = useCallback(() => {
    dispatch(applyJob(selectedJob))
      .unwrap()
      .then((response) => {
        openSnackbar("Successfully applied!", "success");
        // Refresh the jobs list to update the UI
        dispatch(getOpenJobs(params));
      })
      .catch((error) => {
        openSnackbar("Application failed", "error");
      });

    setSelectedJob(null);
    setShowConfirmationModal(false);
  }, [dispatch, selectedJob, params]);

  const handlePage = (count) => {
    setPageCount(count);
  };

  // Modal styles
  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: {
      xs: "90%",   // mobile
      sm: "70%",   // tablet
      md: "600px", // desktop
    },
    maxWidth: "90vw",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
  };

  const SearchField = ({ searchKeyword, handleJobSearch }) => (
    <TextField
      placeholder="Search jobs..."
      variant="outlined"
      size="small"
      fullWidth
      value={searchKeyword}
      onChange={handleJobSearch}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
    />
  );

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: 50 },
  };

  // Loading state
  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="left"
        alignItems="left"
        minHeight="60vh"
        width="100vw"
        padding={"20px"}
      // border="1px solid red"
      >
        <JobsCardsSkeleton />
      </Box>
    );
  }

  // Error state
  // if (error) {
  //   return (
  //     <Box display="flex" justifyContent="center" alignItems="center" sx={{ mt: 4 }}>
  //       <Typography color="error">{error}</Typography>
  //     </Box>
  //   );
  // }
  return (
    <Box
      sx={{
        backgroundColor: "rgba(244, 247, 254, 1)",
        p: 0.5,
        display: "flex",
        flexDirection: "row",
        gap: "10px",
      }}
    >
      <Box
        sx={{
          width: "75%",
          overflowY: "scroll",
          maxHeight: "90vh",
          scrollbarWidth: "none",
        }}
      >
        <Box
          sx={{ display: "flex", flexDirection: "column", gap: "20px", p: 1 }}
          onClick={() => {
            showFilterDropdown && setShowFilterDropdown(false);
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              alignItems: "center",
            }}
          >
            {/* <Link to="/applicant"> */}
            <Button variant="outlined" onClick={handleAppliedClick}>
              Check Applied jobs
            </Button>
            {/* </Link> */}
          </Box>

          {/* Job Cards or No Data Found */}
          {openJobs?.length === 0 ? (
            <Box textAlign="center" p={4}>
              <Typography variant="h6" color="text.secondary">
                {searchKeyword ? "No matches found" : "No jobs available"}
              </Typography>
              <Typography variant="body2" color="text.secondary" mt={1}>
                {searchKeyword
                  ? "Try adjusting your search criteria"
                  : "Check back later for new opportunities"}
              </Typography>
            </Box>
          ) : (
            <Grid container spacing={2}>
              {openJobs?.map((job, index) => (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={viewMode === "grid" ? 4 : 12}
                  key={job?.id}
                  // sx={{ display: "flex", flex: 1 }}
                  sx={{ display: "flex", justifyContent: "center", alignItems: "stretch" }}
                >
                  <Helmet>
                    <meta property="og:title" content={`${job.role} at ${job.company_name}`} />
                    <meta property="og:description" content={`${job.location} | ${job.experience}`} />
                    <meta property="og:image" content={job.company_logo} />
                    <meta property="og:url" content={`${window.location.origin}/job-description/${job.id}`} />
                  </Helmet>
                  <motion.div
                    initial="hidden"
                    animate={isVisible ? "visible" : "hidden"}
                    exit="exit"
                    variants={cardVariants}
                    transition={{
                      delay: index * 0.1, // Staggered animation for each card
                      duration: 0.5,
                    }}
                    // style={{ width: "100%" }}
                    style={{ width: "100%", display: "flex", justifyContent: "center" }}
                  >
                    <Card
                      sx={{
                        boxShadow: 3,
                        borderRadius: 2,
                        width: "100%",
                        // minHeight: viewMode === "grid" ? "min(60vh, 420px)" : "auto",
                        position: "relative",
                        display: "flex",
                        flexDirection: "column",
                        flex: 1,
                        justifyContent: "space-between",
                        p: 3,
                        transition: "transform 0.2s, box-shadow 0.2s",
                        "&:hover": {
                          transform: "translateY(-5px)",
                          boxShadow: 5,
                        },
                      }}
                    >
                      <Box
                        sx={{
                          position: "absolute",
                          top: 8,
                          right: 8,
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <Typography
                          variant="caption"
                          color="gray"
                          sx={{ fontWeight: 500, fontSize: "12px" }}
                        >
                          {renderPostedDate(job?.date_posted)}
                        </Typography>
                        <IconButton
                          size="small"
                          aria-label="share"
                          onClick={(e) => {
                            e.stopPropagation(); // Prevent card click when sharing
                            handleJobShare(job);
                          }}
                          sx={{ fontSize: "16px" }}
                        >
                          {job?.status == "open" ? (
                            <ShareIcon fontSize="small" />
                          ) : (
                            ""
                          )}
                        </IconButton>
                        <IconButton
                          size="small"
                          aria-label="save"
                          sx={{ fontSize: "16px" }}
                          onClick={() => handleJobSave(job?.id)}
                        >
                          {job?.is_saved ? (
                            <BookmarkIcon fontSize="small" />
                          ) : (
                            <BookmarkBorderIcon fontSize="small" />
                          )}
                        </IconButton>
                      </Box>

                      <Box>
                        {/* <Link to={`/job-description/${job?.id}`}> */}
                        <Box
                          sx={{ cursor: "pointer" }}
                          onClick={() => handleSingleJobClick(job?.id)}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 0.5,
                              mb: 0.5,
                            }}
                          >
                            {/* {logourl[job.id] ? ( */}
                            <img
                              width="75px"
                              height="75px"
                              src={
                                job?.company_logo
                                  ? job?.company_logo
                                  : "https://www.shutterstock.com/image-vector/image-icon-trendy-flat-style-600nw-643080895.jpg"
                              }
                              alt="Logo API"
                            />
                          </Box>

                          <Box>
                            {/* Job Role */}
                            <Typography
                              variant="h6"
                              sx={{
                                fontWeight: 600,
                                fontSize: "16px",
                                color: "black",
                              }}
                            >
                              {job?.role}
                            </Typography>
                            {/* Company Name */}
                            <Typography
                              variant="body2"
                              sx={{
                                textAlign: "start",
                                fontSize: "16px",
                                color: "#00000099",
                                p: "3px",
                              }}
                            >
                              {job?.company_name}
                            </Typography>
                          </Box>

                          <Grid
                            container
                            sx={{
                              display: "grid",
                              gridTemplateColumns:
                                viewMode === "list"
                                  ? "repeat(4, 1fr)"
                                  : "repeat(2, 1fr)",
                              gap: viewMode === "list" ? 1 : 0.5,
                              my: "3px",
                              // p: 1,
                              overflowX:
                                viewMode === "list" ? "auto" : "visible",
                              "&::-webkit-scrollbar": { display: "none" },
                              scrollbarWidth: "none",
                            }}
                          >
                            {/* Education Level */}
                            <Grid item>
                              <Typography
                                variant="body2"
                                display="flex"
                                alignItems="center"
                                sx={{
                                  color: "#000000DE",
                                  fontSize: "12px",
                                  // bgcolor: '#f5f5f5',
                                  p:
                                    viewMode === "list"
                                      ? "6px 12px"
                                      : "5px 5px",
                                  borderRadius: 1,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  minWidth:
                                    viewMode === "list" ? "150px" : "auto",
                                  height: "32px",
                                }}
                              >
                                <SchoolIcon
                                  fontSize="small"
                                  sx={{
                                    mr: 1,
                                    color: "#0000008A",
                                    width: "16px",
                                    height: "16px",
                                  }}
                                />
                                {job?.edu_level || "Not Specified"}
                              </Typography>
                            </Grid>

                            {/* Experience */}
                            <Grid item>
                              <Typography
                                variant="body2"
                                display="flex"
                                alignItems="center"
                                sx={{
                                  color: "#000000DE",
                                  fontSize: "12px",
                                  // bgcolor: '#f5f5f5',
                                  p:
                                    viewMode === "list"
                                      ? "6px 12px"
                                      : "5px 5px",
                                  borderRadius: 1,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  minWidth:
                                    viewMode === "list" ? "150px" : "auto",
                                  height: "32px",
                                }}
                              >
                                <WorkOutline
                                  fontSize="small"
                                  sx={{
                                    mr: 1,
                                    color: "#0000008A",
                                    width: "16px",
                                    height: "16px",
                                  }}
                                />
                                {job?.experience || "Not Specified"}
                              </Typography>
                            </Grid>

                            {/* Salary */}
                            <Grid item>
                              <Typography
                                variant="body2"
                                display="flex"
                                alignItems="center"
                                sx={{
                                  color: "#000000DE",
                                  fontSize: "12px",
                                  // bgcolor: '#f5f5f5',
                                  p:
                                    viewMode === "list"
                                      ? "6px 12px"
                                      : "5px 5px",
                                  borderRadius: 1,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  minWidth:
                                    viewMode === "list" ? "150px" : "auto",
                                  height: "32px",
                                }}
                              >
                                <CurrencyRupeeIcon
                                  fontSize="small"
                                  sx={{
                                    mr: 1,
                                    color: "#0000008A",
                                    width: "16px",
                                    height: "16px",
                                  }}
                                />
                                {formatSalary(job?.salary) || "Not Specified"}
                              </Typography>
                            </Grid>

                            {/* Location */}
                            <Grid item>
                              <Typography
                                variant="body2"
                                display="flex"
                                alignItems="center"
                                sx={{
                                  color: "#000000DE",
                                  fontSize: "12px",
                                  // bgcolor: '#f5f5f5',
                                  p:
                                    viewMode === "list"
                                      ? "6px 12px"
                                      : "5px 5px",
                                  borderRadius: 1,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  minWidth:
                                    viewMode === "list" ? "150px" : "auto",
                                  height: "32px",
                                }}
                              >
                                <LocationOn
                                  fontSize="small"
                                  sx={{
                                    mr: 1,
                                    color: "#0000008A",
                                    width: "16px",
                                    height: "16px",
                                  }}
                                />
                                {job?.location?.split(",")[0].trim() ||
                                  "Not Specified"}
                              </Typography>
                            </Grid>
                          </Grid>

                          {/* <Typography
                            variant="body2"
                            sx={{
                              mb: 1.2,
                              fontSize: "14px",
                              color: "#000000DE",
                              mt: 1,
                            }}
                          > */}
                          {/* <CalendarMonthIcon
                              fontSize="small"
                              sx={{
                                mr: 0.5,
                                color: "#0000008A",
                                width: "16px",
                                height: "16px",
                              }}
                            /> */}
                          {/* {(() => {
                              try {
                                // No need to parse, job?.responsibility is already an array
                                const responsibilities = job?.responsibility;

                                if (
                                  Array.isArray(responsibilities) &&
                                  responsibilities?.length > 0
                                ) {
                                  const text = responsibilities.join(" "); // Convert array to string
                                  return (
                                    text.split(" ").slice(0, 10).join(" ") +
                                    "..."
                                  ); // Limit to 10 words
                                }
                              } catch (error) {
                                let text =
                                  job?.responsibility ||
                                  "Responsibility details not available.";

                                // Ensure text is a string before using split
                                if (Array.isArray(text)) {
                                  text = text.join(" "); // Convert array to string
                                }

                                return (
                                  text.split(" ").slice(0, 10).join(" ") + "..."
                                ); // Limit to 10 words
                              }
                            })()}
                            <span
                              style={{
                                color: "#007BFF",
                                cursor: "pointer",
                                marginLeft: 5,
                              }}
                            >
                              ...More
                            </span> */}
                          {/* </Typography> */}

                          <Box
                            sx={{
                              p: 0.2,
                              maxHeight: viewMode == "list" ? "7vh" : "10vh",
                              overflowY: "scroll",
                              scrollbarWidth: "none",
                            }}
                          >
                            {job?.skills ? (
                              <Box
                                sx={{
                                  width: "100%",
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: "8px",
                                  "& > *": {
                                    maxWidth:
                                      viewMode === "list" ? "120px" : "none",
                                  },
                                  maskImage:
                                    "linear-gradient(to bottom, black 80%, transparent 100%)",
                                }}
                              >
                                {parseSkillsArray(job?.skills).map(
                                  (skill, index, arr) => {
                                    const maxSkills =
                                      viewMode === "list" ? 8 : 4;
                                    if (index >= maxSkills) {
                                      if (index === maxSkills) {
                                        return (
                                          <Typography
                                            key="more"
                                            variant="body2"
                                            sx={{
                                              color: "#007BFF",
                                              cursor: "pointer",
                                              fontWeight: "500",
                                              fontSize: "12px",
                                              lineHeight: "20px",
                                            }}
                                          >
                                            +{arr.length - maxSkills} more
                                          </Typography>
                                        );
                                      }
                                      return null;
                                    }
                                    return (
                                      <Typography
                                        key={index}
                                        variant="body2"
                                        sx={{
                                          color: "gray",
                                          fontWeight: "500",
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          fontSize: "12px",
                                          lineHeight: "20px",
                                          backgroundColor: "#f5f5f5",
                                          padding: "2px 8px",
                                          borderRadius: "4px",
                                        }}
                                      >
                                        {skill.trim()}
                                      </Typography>
                                    );
                                  }
                                )}
                              </Box>
                            ) : (
                              <Typography
                                variant="body2"
                                sx={{ color: "gray" }}
                              >
                                Skills not specified.
                              </Typography>
                            )}
                          </Box>
                        </Box>
                        {/* </Link> */}
                      </Box>
                      <Box
                        sx={{
                          width: viewMode === "list" ? "10%" : "30%",
                        }}
                      >
                        <Button
                          variant="contained"
                          color="success"
                          size="small"
                          sx={{
                            width: "100%",
                            "&:disabled": {
                              backgroundColor: "#f5f5f5",
                              color: "text.disabled",
                            },
                          }}
                          onClick={(e) => handleApplyInitiation(job?.id, e)}
                          disabled={job?.status === "close"}
                        >
                          {job?.status === "close" ? "Closed" : "Apply"}
                        </Button>
                      </Box>
                    </Card>
                  </motion.div>

                </Grid>
              ))}
            </Grid>
          )}

          <ShareProfile
            open={shareProfileConfig?.open}
            onClose={shareProfileConfig?.onClose}
            qrCodeUrl={shareProfileConfig?.qrCodeUrl}
            showQr={shareProfileConfig?.showQr}
            profileType={shareProfileConfig?.profileType}
            handleSuccess={shareProfileConfig?.handleSuccess}
            handleFailure={shareProfileConfig?.handleFailure}
            shareData={shareProfileConfig?.shareData}
          />

          <Modal
            open={showConfirmationModal}
            onClose={() => setShowConfirmationModal(false)}
          >
            <Box sx={modalStyle}>
              <Typography variant="h6" gutterBottom>
                Confirm Application
              </Typography>
              <Typography variant="body1" sx={{ mb: 3 }}>
                Are you sure you want to apply for this position?
              </Typography>
              <Box sx={{ display: "flex", gap: 2, justifyContent: "right" }}>
                <Button
                  variant="outlined"
                  onClick={() => setShowConfirmationModal(false)}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  onClick={handleJobApplyConfirmation}
                >
                  Confirm Apply
                </Button>
              </Box>
            </Box>
          </Modal>

          {/* Resume Required Modal */}
          <Modal
            open={showResumeModal}
            onClose={() => setShowResumeModal(false)}
          >
            <Box sx={modalStyle}>
              <Typography variant="h6" gutterBottom>
                Resume Required
              </Typography>
              <Typography variant="body1" sx={{ mb: 3 }}>
                Please generate your AI Resume to apply for this position.
              </Typography>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  variant="contained"
                  onClick={() => {
                    setShowResumeModal(false);
                    navigate("/myprofile?mainTab=professional_profile&subTab=resume");
                  }}
                >
                  Generate AI Resume
                </Button>
              </Box>
            </Box>
          </Modal>

          {/* Video Resume Suggested Modal */}
          <Modal open={showVideoModal} onClose={() => setShowVideoModal(false)}>
            <Box sx={modalStyle}>
              <Typography variant="h6" gutterBottom>
                Video Resume Required
              </Typography>
              <Typography variant="body1" sx={{ mb: 3 }}>
                A video resume is mandatory to apply for this position. Create
                your video resume to proceed with the application.
              </Typography>
              <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                  variant="contained"
                  onClick={() => {
                    setShowVideoModal(false);
                    navigate("/myprofile?mainTab=professional_profile&subTab=resume");
                  }}
                >
                  Create Video Resume
                </Button>
              </Box>
            </Box>
          </Modal>
        </Box>
        <Box
          sx={{ display: "flex", justifyContent: "center", padding: "20px" }}
        >
          <Box sx={{ display: "flex", justifyContent: "center", mt: 3, mb: 3 }}>
            {pagination?.totalPages > 1 && (
              <CandidatePagination
                totalPages={pagination?.totalPages}
                currentPage={pageCount + 1}
                onPageChange={handlePage}
              />
            )}
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          // position: "sticky",
          top: "110px", // Distance from the top of the viewport
          alignSelf: "flex-start", // Ensures it stays at the start of the parent container
          width: "30%", // Set appropriate width for the JobOpenings component
          // zIndex: 1000, // Ensure it stays above other elements if necessary
          overflowY: "scroll",
          maxHeight: "90vh",
          scrollbarWidth: "none",
          padding: "10px",
        }}
      >
        {/* <PersonalCalender /> */}
        <FilterComponent
          filterOptions={otherJobs?.filters || {}}
          onApply={handleApplyFilters}
          onClear={handleClearFilters}
        />
      </Box>
    </Box>
  );
};

export default OtherJobs;
